var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"main-wrapper"}},[_c('Header-Partial'),(_vm.getHeader)?_c('div',{staticClass:"row",staticStyle:{"width":"100%"}},[_c('router-view')],1):_c('div',[_vm._v(" getHeader = "+_vm._s(_vm.getHeader)+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }